import { atom, useAtom } from 'jotai';
import { IModel } from '@/types';

// 选中的 model 全局 atom
export const modelAtom = atom<IModel | null>(null);

// 便于使用的 hook
export function useModel() {
  return useAtom(modelAtom);
}





//  文件列表
export const fileListAtom = atom([]);

export function useFileList() {
  return useAtom(fileListAtom);
}

